import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import ChatBot from './ChatBot';
import AdminApp from './admin/AdminApp';
import { BrandProvider, useBrand } from './BrandContext';
import { createBrandTheme } from './theme';

function ThemedApp() {
  const { config } = useBrand();
  const theme = createBrandTheme(config);

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/*" element={<ChatBot />} />
      </Routes>
    </ThemeProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <BrandProvider>
        <ThemedApp />
      </BrandProvider>
    </BrowserRouter>
  );
}

export default App;
